import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { History , X } from "lucide-react";
import { hasAccess } from "utils/access";
import AuditPanel from "./AuditPanel";
import s from "../Management.module.scss";

export default function AuditButton({
  section,
  objectId,
  objectType,
  actorId,
}) {
  useInterfaceLanguage();
  const user = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  if (!hasAccess(user, "audit")) return null;
  return (
    <span onClick={(event) => event.stopPropagation()}>
      <button type="button" className={s.button} onClick={() => setOpen(true)}>
        <History size={13} />{tr("Логи")}</button>
      {tr(open && (
        <div className={s.overlay}>
          <div
            className={s.dialog}
            role="dialog"
            aria-modal="true"
            aria-label={tr("Журнал объекта")}
            style={{ width: "min(1100px,100%)" }}
          >
            <div
              className={s.footer}
              style={{
                border: 0,
                marginTop: 0,
                paddingTop: 0,
                marginBottom: 12,
              }}
            >
              <button type="button" className={s.button} onClick={() => setOpen(false)}><X size={14} aria-hidden="true"/>{tr("Закрыть")}</button>
            </div>
            <AuditPanel
              section={section}
              objectId={objectId}
              objectType={objectType}
              actorId={actorId}
            />
          </div>
        </div>
      ))}
    </span>
  );
}
